import { StaticImageData } from 'next/image'
import { ReactNode } from 'react'

import tg from '../page/assets/space_tg.svg'
import vk from '../page/assets/space_vk.svg'
import why1 from '../page/assets/why-0.png'
import why2 from '../page/assets/why-1.png'
import why3 from '../page/assets/why-2.png'
import why4 from '../page/assets/why-3.png'
import why1w from '../page/assets/why-white-0.png'
import why2w from '../page/assets/why-white-1.png'
import why3w from '../page/assets/why-white-2.png'
import why4w from '../page/assets/why-white-3.png'

// Base URL for external assets
const BASE_IMAGE_URL = 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new'

// Data for WhyCard section
interface WhyCardItem {
	iconSrc: StaticImageData
	iconSrcHover: StaticImageData
	title: string
	subtitle: string | ReactNode
}

export const whyCardItems: WhyCardItem[] = [
	{
		iconSrc: why1,
		iconSrcHover: why1w,
		title: 'Оригинальная техника',
		subtitle: <p>Товар официально ввезён в страну</p>
	},
	{
		iconSrc: why2,
		iconSrcHover: why2w,
		title: 'Обслуживание с гарантией качества',
		subtitle: <p>Собственные сервисные центры</p>
	},
	{
		iconSrc: why3,
		iconSrcHover: why3w,
		title: 'Поддержка экспертов',
		subtitle: <p>От выбора устройства до настроек</p>
	},
	{
		iconSrc: why4,
		iconSrcHover: why4w,
		title: 'Гарантия 2 года*    ',
		subtitle: (
			<>
				<p>
					Расширенная защита
					<br /> на технику Apple.
				</p>
				<p>*На наушники Apple гарантия составляет 12 месяцев.</p>
			</>
		)
	}
]

// Data for AdvantageCard section
interface AdvantageCardItem {
	title: string
	subtitle: string
	backgroundImage: string
	subtitleColor?: string
}

export const advantageCardItems: AdvantageCardItem[] = [
	{
		title: 'Широкий ассортимент        ',
		subtitle: 'Огромный выбор техники мировых брендов и аксессуаров.',
		backgroundImage: `${BASE_IMAGE_URL}/card-1.jpg`
	},
	{
		title: 'Наши магазины        ',
		subtitle: 'Современные магазины в удобных и популярных локациях городов по всей России.',
		backgroundImage: `${BASE_IMAGE_URL}/card-2.jpg`,
		subtitleColor: '#fff'
	},
	{
		title: 'Кэшбэк за покупки',
		subtitle: 'Оплачивайте до 99% стоимости бонусами.',
		backgroundImage: `${BASE_IMAGE_URL}/card-3.jpg`
	}
]

// Data for About section images
interface AboutImage {
	src: string
	width: number
	height: number
	alt: string
	mobileWidth?: number
	mobileHeight?: number
}

export const aboutImages: AboutImage[] = [
	{
		src: `${BASE_IMAGE_URL}/iPortNew.png`,
		width: 172,
		height: 45,
		alt: 'iPort Logo',
		mobileWidth: 112,
		mobileHeight: 30
	},
	{
		src: `${BASE_IMAGE_URL}/iPortNew-service.png`,
		width: 222,
		height: 45,
		alt: 'iPort Service Logo',
		mobileWidth: 144,
		mobileHeight: 30
	},
	{
		src: `${BASE_IMAGE_URL}/LogoSamsung.png`,
		width: 167,
		height: 45,
		alt: 'Samsung Logo',
		mobileWidth: 112,
		mobileHeight: 28
	},
	{
		src: `${BASE_IMAGE_URL}/B2B_NBCOM_logo.png`,
		width: 181,
		height: 49,
		alt: 'B2B NBCOM Logo',
		mobileWidth: 117,
		mobileHeight: 31
	},
	{
		src: `${BASE_IMAGE_URL}/LogoSamsung-Service.png`,
		width: 154,
		height: 45,
		alt: 'Samsung Service Logo',
		mobileWidth: 99,
		mobileHeight: 29
	},
	{
		src: `${BASE_IMAGE_URL}/huawei.png`,
		width: 150,
		height: 50,
		alt: 'Huawei Logo',
		mobileWidth: 109,
		mobileHeight: 37
	}
]

interface SubscribeItem {
	iconId: string
	title: string
	description: string
	link: string
	linkTitle: string
	background: string
	color: string
	backgroundMob: string
}

// Existing SubscribeLine items
export const subscribeItems: SubscribeItem[] = [
	{
		iconId: tg,
		color: '#28A8E9',
		title: 'iPort в Telegram',
		description: 'Дарим 300 бонусов за подписку',
		link: 'https://t.me/iport_apple/1675',
		linkTitle: 'Перейти к нашей группе в Telegram',
		background: `${BASE_IMAGE_URL}/social-1.jpg`,
		backgroundMob: `${BASE_IMAGE_URL}/social-mob-1.jpg`
	},
	{
		iconId: vk,
		color: '#0077FF',
		title: 'iPort в VK',
		description: 'Сообщество о технике Apple',
		link: 'https://vk.com/iport_apple',
		linkTitle: 'Перейти к нашей группе в Вконтакте',
		background: `${BASE_IMAGE_URL}/social-2.jpg`,
		backgroundMob: `${BASE_IMAGE_URL}/social-mob-2.jpg`
	}
]

interface SpaceJoinProps {
	imageSrc: string
	alt?: string
	title: string
	subtitle: string
	link: string
}

export const joinData: SpaceJoinProps = {
	imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/bottom-img.jpg`,
	title: `Присоединяйся к нашей команде`,
	subtitle: `Узнать о доступных вакансиях`,
	link: `https://nbcomgroup.ru/`
}

interface SpaceSliderProps {
	imageSrc: string
	title: string
	link: string
}

export const SpaceSliderData: SpaceSliderProps[] = [
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-0.png`,
		title: `Закажите <br/> с доставкой`,
		link: `/delivery/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-1.png`,
		title: `Оплатите<br/>  бонусами`,
		link: `/services/iport-card/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-2.png`,
		title: `Обменяйте <br/> в Трейд-ин`,
		link: `/services/trade-in/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-3.png`,
		title: `Тестируйте <br/> технику перед покупкой`,
		link: `/shops/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-4.png`,
		title: `Сплитуйте<br/>  с Яндекс Сплит`,
		link: `/split/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-5.png`,
		title: `Оплатите <br/> по QR-коду`,
		link: `/delivery/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-6.png`,
		title: `Застрахуйте<br/>  устройство`,
		link: `/services/insurance/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-7.png`,
		title: `Продлите<br/>  гарантию `,
		link: `/services/plus/`
	},
	{
		imageSrc: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/icon-8.png`,
		title: `Воспользуйтесь<br/>  рассрочкой`,
		link: `/services/credit/`
	}
]
